import "./style.css";
import gsap from "gsap";
import inView from "in-view";
import Masonry from "masonry-layout";

export default class LayoutCards {
  static selector = ".s-section__cards";

  constructor(block) {
    this.block = block;
    this.loadedContent = false;
    const isHome = document.body.classList.contains("home");
    const homeLayout = parseInt(block.getAttribute("data-home"), 10) === 1;

    if (isHome && homeLayout) {
      this.$homeCourses = document.body.querySelector(
        ".s-article__home-courses"
      );
      this.arrangeHomeElements();
      inView(".s-article__home-courses").on(
        "enter",
        this.onEnterView.bind(this)
      );
    } else {
      if (!isHome) {
        this.block.querySelector(".s-layout__cards").classList.add("masonry");
        this.$msnry = new Masonry(".s-layout__cards-content", {
          itemSelector: ".s-card",
        });
      }
    }
  }

  onEnterView() {
    this.$homeCourses.classList.add("in-view");
  }

  arrangeHomeElements() {
    const $grid1 = document.querySelector(".s-grid__content1");
    const $grid2 = document.querySelector(".s-grid__content2");

    const $courses = document.querySelector(".s-homepage-courses");
    const $cardsContent = this.block.querySelector(".s-layout__cards-content");
    const $cards = $cardsContent.querySelectorAll(".s-card");

    $cardsContent.innerHTML = "";
    $cardsContent.parentNode.appendChild($courses);

    $grid1.appendChild($cards[0]);
    if ($cards[1]) $grid2.appendChild($cards[1]);
    if ($cards[2]) $grid2.appendChild($cards[2]);
    if ($cards[3]) $grid2.appendChild($cards[3]);
  }

  serialize(obj) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  }

  parseHTML(html) {
    this.loadedContent = true;

    const div = document.createElement("div");
    div.innerHTML = html;
    const $cardsContent = this.block.querySelector(".s-layout__cards-content");

    const $cards = div.querySelectorAll(".s-layout__cards-content .s-card");
    $cards.forEach(($el, i) => {
      $el.classList.add(`s-card-page-${this.pages}`);
      gsap.to($el, {
        duration: 1,
        delay: i * 0.02,
        autoAlpha: 1,
      });

      $cardsContent.appendChild($el);
      this.$msnry.appended($el);
    });

    const maxPages = parseInt(this.block.getAttribute("data-pages"));
    if (this.pages >= maxPages) {
      this.block.querySelector(".s-layout__cards-cta").innerHTML = "";
    }
  }

  onLoadMore(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const params = new URLSearchParams(window.location.search);
    const paramsObj = Array.from(params.keys()).reduce(
      (acc, val) => ({ ...acc, [val]: params.get(val) }),
      {}
    );

    const queryParams = [];
    if (paramsObj.category) queryParams.push(`category=${paramsObj.category}`);

    let nextPage;
    if (!this.loadedContent)
      nextPage = paramsObj.pg ? parseInt(paramsObj.pg, 10) + 1 : 2;
    else nextPage = this.pages += 1;

    queryParams.push(`pg=${nextPage}`);
    this.pages = nextPage;

    const url = `${window.location.origin}${
      window.location.pathname
    }?${queryParams.join("&")}`;

    window.App.loadUrl(url).then(this.parseHTML.bind(this));
  }

  init() {
    this.pages = parseInt(this.block.getAttribute("data-pages"), 10);
    if (this.pages > 1) {
      const $button = this.block.querySelector(
        ".s-layout__cards-cta .s-button"
      );

      $button.addEventListener("click", this.onLoadMore.bind(this));
    }
  }

  onReady() {
    this.init();
  }
}
